import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'
import queryString from 'query-string'
import { useQuery } from 'react-query'
import AnnualFeedbackForm from './annual-feedback-form'
import ProjectFeedbackForm from './project-feedback-form'
import { retrieveClient } from '../../api/feedback'

Modal.setAppElement('body')

const FeedbackModal = () => {
  const [token, setToken] = useState(null)
  const [isClient, setIsClient] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsClient(true)

    if (typeof window === 'undefined') {
      return
    }

    const parsed = queryString.parse(window.location.search)
    const parsedToken = Array.isArray(parsed.token) ? parsed.token[0] : parsed.token

    if (parsedToken) {
      setToken(parsedToken)
      setIsOpen(true)
    }
  }, [])

  const { data, isLoading, isError, error } = useQuery(
    ['feedback-client', token],
    () => retrieveClient(token),
    {
      enabled: !!token,
      retry: 1,
    }
  )

  const handleSuccess = () => {
    setIsOpen(false)
  }

  if (!isClient || !token) {
    return null
  }

  return (
    <Modal
      isOpen={isOpen}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      overlayClassName="c-feedback-modal__overlay"
      className="c-feedback-modal"
      contentLabel="Feedback form"
    >
      {isLoading && <p>Loading your feedback request...</p>}

      {isError && (
        <div className="f-messages">
          <div className="f-messages__alert f-messages__alert--error">
            <p>{error?.message || 'We could not load your feedback form. Please try again later.'}</p>
          </div>
        </div>
      )}

      {!isLoading && !isError ? (
        <>
          {data?.type === 'ANNUAL_FEEDBACK' && (
            <AnnualFeedbackForm
              token={token}
              customerFirstName={data?.customer_first_name}
              onSuccess={handleSuccess}
            />
          )}
          {data?.type === 'PROJECT_FEEDBACK' && (
            <ProjectFeedbackForm
              token={token}
              customerFirstName={data?.customer_first_name}
              projectTitle={data?.project_title}
              onSuccess={handleSuccess}
            />
          )}
          {!data?.type && (
            <div className="f-messages">
              <div className="f-messages__alert f-messages__alert--error">
                <p>The feedback link you used is not valid. Please contact your Outsmart Insight lead.</p>
              </div>
            </div>
          )}
        </>
      ) : null}
    </Modal>
  )
}

export default FeedbackModal

